import { UIButtonKind } from '../ui/component/button';
import { UIInputKind } from '../ui/component/input-base';
import { UISegmentedKind } from '../ui/component/segmented';
import { $el } from '../ui/elements';
import { UIClassesSpec } from '../ui/types';
import { UIViewAddSpec } from '../ui/view';

export function fakeText(size: number) {
    const span = $el.SPAN('ed-fake-text');
    span.style.width = size + 'em';
    return span;
}

export function fakeInput(title: string, kind: UIInputKind = 'k-line', classes?: UIClassesSpec) {
    return $el.DIV(['ui-input', kind, 'i-input', 'i-horizontal', classes], $el.DIV('r-core', $el.DIV('r-field', title)));
}

export function fakeButton(content: UIViewAddSpec, kind: UIButtonKind = 'k-default', classes?: UIClassesSpec) {
    return $el.DIV(['ui-button', kind, classes], content);
}

export function fakeSegmented(kind: UISegmentedKind) {
    const inkbar = $el.DIV('ui-inkbar');
    inkbar.style.left = '135px';
    inkbar.style.right = '0px';
    return $el.DIV(['ui-toggles', 'ui-segmented', kind], [inkbar, $el.DIV('r-segment', 'Göteborg'), $el.DIV(['r-segment', 'f-checked'], 'Stockholm')]);
}